export const iconFontAwesomeMapsRestroom = (
	<i className="fa-solid fa-restroom"></i>
);
